const LUPZ_POPUP_PANEL_SELECTOR = '.lupz-series-popup-panel, .lupz-popup-panel';

const updateMobileDots = (scroller) => {
  if (!scroller) {
    return;
  }

  const host = scroller.closest('.lupz-popup-mobile-gallery-host');

  if (!host) {
    return;
  }

  const dots = host.querySelectorAll('.lupz-popup-mobile-dots span');

  if (!dots.length) {
    return;
  }

  const slideWidth = scroller.clientWidth || 1;
  const activeIndex = Math.round(scroller.scrollLeft / slideWidth);

  for (const [index, dot] of dots.entries()) {
    dot.classList.toggle('is-active', index === activeIndex);
  }
};

const resetMobileGallery = (panel) => {
  const scroller = panel?.querySelector('.lupz-popup-mobile-image-scroll');

  if (!scroller) {
    return;
  }

  scroller.scrollLeft = 0;
  updateMobileDots(scroller);
};

const bindScroller = (scroller) => {
  if (scroller.dataset.lupzMobileGalleryBound === 'true') {
    return;
  }

  scroller.dataset.lupzMobileGalleryBound = 'true';

  scroller.addEventListener(
    'scroll',
    () => {
      window.requestAnimationFrame(() => updateMobileDots(scroller));
    },
    { passive: true }
  );
};

const observePanelOpen = (panel) => {
  if (panel.dataset.lupzMobileGalleryObserved === 'true') {
    return;
  }

  panel.dataset.lupzMobileGalleryObserved = 'true';

  const observer = new MutationObserver(() => {
    if (panel.classList.contains('is-open')) {
      resetMobileGallery(panel);
    }
  });

  observer.observe(panel, {
    attributes: true,
    attributeFilter: ['class'],
  });
};

const initMobileGalleries = () => {
  for (const scroller of document.querySelectorAll('.lupz-popup-mobile-image-scroll')) {
    bindScroller(scroller);
  }

  for (const panel of document.querySelectorAll(LUPZ_POPUP_PANEL_SELECTOR)) {
    observePanelOpen(panel);
  }
};

document.addEventListener('DOMContentLoaded', initMobileGalleries);

const galleryObserver = new MutationObserver(() => {
  initMobileGalleries();
});

galleryObserver.observe(document.body, { childList: true, subtree: true });
